import React from 'react'
import styled from 'styled-components'

import colors from 'styles/colors'
import text from 'styles/text'
import media from 'styles/media'

type Props = {
  href: string
}

const NavLink: React.FC<Props> = ({ children, href}) => {

  const handleClick = () => {
    window.open(href, "_blank")
  }

  return (
    <Wrapper onClick={handleClick}>
      {children}
      <HR/>
      <HR1/>
    </Wrapper>
  )
}

export default NavLink

const HR = styled.div`
  background: ${colors.black75};
  width: 100%;
  height: 1px;
  transition: 500ms;

  margin-top: 0.14vw;

  ${media.tablet} {
    margin-top: 0.2vw;
  }
`

const HR1 = styled(HR)`
  background: ${colors.horzGradient};
  width: 0%;
  position: absolute;

  left: 1.39vw;
  bottom: 0.63vw;

  ${media.tablet} {
    left: 2vw;
    bottom: 0.88vw;
  }
` 

const Wrapper = styled.div`
  position: relative;
  ${text.desktop.bodyS}
  text-decoration: none;
  width: fit-content;
  color: ${colors.pureWhite};
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  backdrop-filter: blur(1px);
  border-radius: 2px;
  
  height: 2.78vw;
  padding-left: 1.39vw;
  padding-right: 1.39vw;
  padding-top: 0.28vw;
  padding-bottom: 0.63vw;

  ${media.tablet} {
    ${text.tablet.bodyS}
    height: 3.91vw;
    padding-left: 2vw;
    padding-right: 2vw;
    padding-top: 0.39vw;
    padding-bottom: 1.17vw;
  }

  &:hover {
    ${HR1} {
      width: calc(100% - 1.39vw - 1.39vw);

      ${media.tablet} {
        width: calc(100% - 2vw - 2vw);
      }
    }
  }
`

